/**
 * @ Author: Mars Santoso (marssantoso@hotmail.com)
 * @ Create Time: 2019-10-13 01:11:49
 * @ Modified by: Mars Santoso
 * @ Modified time: 2019-10-13 03:52:34
 * @ Description: index.js
 */

module.exports = require('./lib/initials')
